export default "__VITE_ASSET__DT8rOrdf__"